module.exports = __webpack_public_path__ + "static/f14-dfd7bb8ff1a8165318d4c995d1f19a47.jpeg";